import { jsx as $ } from "react/jsx-runtime";
import l from "react";
import p from "swr";
import { f as P } from "./fetcher.CPHInLJD.js";
import { u as ee } from "./use-formatted-date.6zMpaWWb.js";
const te = 5, oe = (t) => {
  var u, s, a, c;
  const e = t == null ? void 0 : t.fields.url.value, i = p(e, P, {
    revalidateOnFocus: !1,
    dedupingInterval: te * 60 * 1e3,
    keepPreviousData: !0
  });
  return {
    ...i,
    erWaitTimes: ((s = (u = i.data) == null ? void 0 : u.rss) == null ? void 0 : s.channel.item) || [],
    pubDate: (c = (a = i.data) == null ? void 0 : a.rss) == null ? void 0 : c.channel.pubDate
  };
}, j = l.createContext(void 0), ce = (t) => t && !("children" in t), ue = ({ sticky: t, headerProps: e, children: i, isModule: u = !1 }) => {
  var v, W, E, S, w, x, L, b, D, C, I, R, H, O, h, y, A, N, U, k, B;
  const [s, a] = l.useState(!1), [c, G] = l.useState(null), [V, Y] = l.useState(), q = l.useCallback((o) => {
    G((n) => {
      var K, Q;
      if (o === null) return null;
      const M = o.href === ((K = n == null ? void 0 : n.prev) == null ? void 0 : K.href);
      return {
        ...o,
        prev: M ? ((Q = n == null ? void 0 : n.prev) == null ? void 0 : Q.prev) || null : n
      };
    });
  }, []), z = l.useMemo(() => t, [t]), [F, J] = l.useState(!1);
  l.useEffect(() => {
    const o = () => {
      J(window.scrollY > 10);
    };
    return window.addEventListener("scroll", o, { passive: !0 }), o(), () => {
      window.removeEventListener("scroll", o);
    };
  }, []);
  const r = _(), m = _();
  l.useEffect(() => {
    var o, n;
    s ? (o = document == null ? void 0 : document.body) == null || o.classList.add("overflow-hidden") : (n = document.body) == null || n.classList.remove("overflow-hidden");
  }, [s]);
  const { erWaitTimes: d } = oe((E = (W = (v = e == null ? void 0 : e.fields) == null ? void 0 : v.site) == null ? void 0 : W.header) == null ? void 0 : E.erWaitTimeEndpoints), f = (w = (S = e == null ? void 0 : e.fields) == null ? void 0 : S.erWaitTime) != null && w.individualErFeed ? d.find((o) => {
    var n, M;
    return (o == null ? void 0 : o.title) === ((M = (n = e.fields) == null ? void 0 : n.erWaitTime) == null ? void 0 : M.individualErFeed);
  }) : d == null ? void 0 : d[0], { timeStampWithDate: g, timeStamp: T } = ee(
    f == null ? void 0 : f.pubDate.replace("AKDT", "-0800").replace("AKST", "-0900")
  ), X = ((D = (b = (L = (x = e == null ? void 0 : e.fields) == null ? void 0 : x.location) == null ? void 0 : L.search) == null ? void 0 : b.searchPage) == null ? void 0 : D.url) || ((H = (R = (I = (C = e == null ? void 0 : e.fields) == null ? void 0 : C.site) == null ? void 0 : I.search) == null ? void 0 : R.searchPage) == null ? void 0 : H.url) || "/search", Z = ((A = (y = (h = (O = e == null ? void 0 : e.fields) == null ? void 0 : O.location) == null ? void 0 : h.search) == null ? void 0 : y.searchBarPlaceholderText) == null ? void 0 : A.value) || ((B = (k = (U = (N = e == null ? void 0 : e.fields) == null ? void 0 : N.site) == null ? void 0 : U.search) == null ? void 0 : k.searchBarPlaceholderText) == null ? void 0 : B.value) || void 0;
  return /* @__PURE__ */ $(
    j.Provider,
    {
      value: {
        isSticky: z,
        isScrolled: F,
        erWaitTimeModalOpen: r.open,
        openERWaitTimeModal: r.openModal,
        closeERWaitTimeModal: r.closeModal,
        toggleERWaitTimeModal: r.toggleModal,
        changeLocationModalOpen: m.open,
        openChangeLocationModal: m.openModal,
        closeChangeLocationModal: m.closeModal,
        toggleChangeLocationModal: m.toggleModal,
        mobileMenuOpen: s,
        setMobileMenuOpen: a,
        selectedMenuItem: c,
        setSelectedMenuItem: q,
        erWaitTimeStamp: T || void 0,
        erWaitTimeStampWithDate: g || void 0,
        erWaitTimeLocationDetails: f,
        erWaitTimes: d,
        siteSearchPlaceholder: Z,
        siteSearchQuery: V,
        siteSearchUrl: X,
        setSubmitSiteSearchQuery: Y,
        isModule: u
      },
      children: i
    }
  );
}, de = () => {
  const t = l.useContext(j);
  if (!t)
    throw new Error("useHeaderContext must be used within a HeaderProvider");
  return t;
}, _ = () => {
  const [t, e] = l.useState(!1);
  return { open: t, openModal: () => e(!0), closeModal: () => e(!1), toggleModal: () => {
    let a = !1;
    return e((c) => (a = !c, a)), a;
  } };
};
export {
  ue as H,
  oe as a,
  ce as i,
  de as u
};
